import { createSlice } from '@reduxjs/toolkit'

export const CustomerAuthentication = createSlice({
    name: 'customerAuthentication',
    initialState: {
        isCustomerAuthenticated: false,
    },
    reducers: {
        setCustomerAuthenticate: (state, action) => { state.isCustomerAuthenticated = action.payload },
    },
})

// Action creators are generated for each case reducer function
export const { setCustomerAuthenticate } = CustomerAuthentication.actions

export default CustomerAuthentication.reducer